import styled from "@emotion/styled";
import { ButtonProps } from "goi_common";

const RenewalButton = ({ children, onClick, className, disabled }: ButtonProps) => {
  return (
    <Button className={className} onClick={onClick} disabled={disabled}>
      {children}
    </Button>
  );
};

export default RenewalButton;

const Button = styled("button")`
  padding: 12px 0;
  background: white;
  border-radius: 6px;
  width: 100%;
`;
